import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';
import { useHistory, useLocation, withRouter } from 'react-router-dom';
import deferRender from 'defer-render-hoc';

import JourneyList from 'modules/journey/list/List';
import { AssignedJourneyCard } from 'modules/journey/card';
import { journeyCardEnhancer } from 'modules/journey/card/hoc';
import { EmptyListStyled, LoadingListStyled } from 'modules/journey/list/styled/';
import { styledList } from './styled';

import {
  getJourneysObject,
  getJourneyFields,
  getJourneyStopFields,
  getIsDriverJourneysLoading,
} from './redux/selectors';

const enhance = compose(
  injectIntl,
  deferRender,
  withRouter,
  journeyCardEnhancer({
    getJourneyFields,
    getJourneyStopFields,
    getJourneyAdditionalDocumentsFields: () => ({}),
  })
);

const t = {
  no_journeys: 'no jobs',
};

const DriverJourneysList = React.memo(({ className }) => {
  const history = useHistory();
  const location = useLocation();

  const handleClick = useCallback(
    (id) => {
      const clickedFromTasks = location?.pathname?.includes('tasks');
      const pathToGo = clickedFromTasks ? `/tasks/${id}` : `/jobs/${id}`;

      history.push(pathToGo);
    },
    [history, location]
  );

  const journeys = useSelector(getJourneysObject);
  const loading = useSelector(getIsDriverJourneysLoading);
  const hasJourneys = !!Object.keys(journeys || {}).length;

  return (
    <>
      {!loading && hasJourneys && (
        <div className={className}>
          <JourneyList
            grouped={journeys}
            hideTitle
            loadingComponent={LoadingListStyled}
            cardComponent={AssignedJourneyCard}
            onCardClick={handleClick}
          />
        </div>
      )}

      {!loading && !hasJourneys && <EmptyListStyled>{t.no_journeys}</EmptyListStyled>}
      {loading && <LoadingListStyled />}
    </>
  );
});

export default enhance(styledList(DriverJourneysList));
